export default __webpack_public_path__ + "static/media/10.c7d9abed.mp3";